import PropTypes from 'prop-types'
import React from 'react'

import { useBrandGraphic } from '../../../Designs/blocs/brandResolvers'
import { useRoomDesign } from '../../../Designs/blocs/useRoomDesign'

import './WebinarRoomHeaderComponent.scss'

const WebinarRoomHeaderComponent = ({ children }) => {
  const roomDesign = useRoomDesign()
  const resolveBrandGraphic = useBrandGraphic()

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const logo = roomDesign?.graphics?.logo

  const brandedLogo = resolveBrandGraphic(logo)

  return (
    <div className="webinar-room-header-component">
      {logo && (
        <img
          className="site-logo"
          src={brandedLogo}
          alt=""
          onError={(event) => {
            // eslint-disable-next-line no-param-reassign
            event.currentTarget.style.display = 'none'
          }}
        />
      )}
      {children}
    </div>
  )
}

WebinarRoomHeaderComponent.propTypes = {
  children: PropTypes.node,
}

export default WebinarRoomHeaderComponent
